var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-tip",style:({
		'margin-bottom':
			_vm.moreText.length > 0 && !_vm.getPasswordStrength ? '38px' : '22px',
	})},[_vm._t("default",null,{"v":_vm.isShow}),_c('transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('div',{staticClass:"red-txt"},[_vm._v(" "+_vm._s(_vm.remindText)+" "),(!_vm.getPasswordStrength)?_c('ul',_vm._l((_vm.moreText),function(text,i){return _c('li',{key:i,staticClass:"more-txt"},[_vm._v(" "+_vm._s(text)+" ")])}),0):_vm._e()]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }